module.exports = "<div class=\"footer\">\n  <div class=\"pull-right\">\n    10GB of <strong>250GB</strong> Free.\n  </div>\n  <div>\n    <strong>Copyright</strong> Example Company &copy; 2014-2017\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/footer/footer.template.html
// module id = ./src/app/components/common/footer/footer.template.html
// module chunks = main